export default __webpack_public_path__ + "assets/images/9ed60f5342292778799207662cd9aff9.png";